/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-runloop, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { later } from '@ember/runloop';
// Internal Imports
import ProcessMonitorStatus from '@linc-technologies/linced-common/enums/process-monitor-status';
import { tracked } from '@glimmer/tracking';

export default class ProcessMonitorProgress extends Component {
  ProcessMonitorStatus = ProcessMonitorStatus;

  @service
  store;

  @service
  toaster;

  pollRate = 1;
  monitorIds = [];
  completeCallback() {}
  @tracked totalNumItems = 0;
  @tracked currentNumItems = 0;

  didInsertElement() {
    super.didInsertElement(...arguments);
    this.pollProcessMonitor();
  }

  async pollProcessMonitor() {
    try {
      const ids = this.monitorIds.filter((id) => !isEmpty(id));

      // fetch all at once, order matches `ids`
      const monitors = await Promise.all(
        ids.map((id) =>
          this.store.findRecord('cron/process-monitor', id, { reload: true }),
        ),
      );

      // compute totals + finished flag
      let totalNumItems = 0;
      let currentNumItems = 0;
      let allFinished = true;

      for (const monitor of monitors) {
        if (!isEmpty(monitor.progress)) {
          totalNumItems += monitor.progress.totalNumItems || 0;
          currentNumItems += monitor.progress.currentItemNum || 0;
        }

        if (
          monitor.status !== ProcessMonitorStatus.COMPLETE &&
          monitor.status !== ProcessMonitorStatus.FAILED
        ) {
          allFinished = false;
        }
      }

      this.totalNumItems = totalNumItems;
      this.currentNumItems = currentNumItems;

      if (allFinished && monitors.length) {
        this.completeCallback(monitors);
        return;
      }

      later(
        this,
        this.pollProcessMonitor,
        Math.max(50, 1000 / (this.pollRate || 1)),
      );
    } catch (e) {
      this.toaster.error(`Failed to check progress: ${e}`);
    }
  }
}
